"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subtractNano = exports.addNano = exports.fromNANOString = exports.NANOToNumber = exports.rawToNANO = void 0;
const models_1 = require("../models");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const nanocurrency_web_1 = require("nanocurrency-web");
function rawToNANO(raw) {
    return nanocurrency_web_1.tools.convert(raw, 'RAW', 'NANO');
}
exports.rawToNANO = rawToNANO;
function NANOToNumber(nano) {
    const number = new bignumber_js_1.default(nano.asString);
    return Number.parseFloat(number.toFixed(number.decimalPlaces()));
}
exports.NANOToNumber = NANOToNumber;
function fromNANOString(nano) {
    return models_1.NANO.fromRAW(nanocurrency_web_1.tools.convert(nano, 'NANO', 'RAW'));
}
exports.fromNANOString = fromNANOString;
function addNano(one, second) {
    return fromNANOString(new bignumber_js_1.default(one.asString).plus(new bignumber_js_1.default(second.asString)).toString());
}
exports.addNano = addNano;
function subtractNano(one, second) {
    return fromNANOString(new bignumber_js_1.default(one.asString).minus(new bignumber_js_1.default(second.asString)).toString());
}
exports.subtractNano = subtractNano;
